const rootElm = window.document.documentElement

function setRootFontSize() {
  const width = rootElm.getBoundingClientRect().width

  rootElm.style.fontSize = width / 37.5 + 'px'
}

setRootFontSize()

window.addEventListener('resize', setRootFontSize)
